import React from "react";
import classes from "./TickComponent.scss";
import { TickCircleOutlined, DashedCircleOutlined } from "@toddle-edu/ds-icons";
import PropTypes from "prop-types";

const TickComponent = ({ isCompleted }) => {
  return (
    <div className={classes.tickContainer}>
      {isCompleted ? (
        <TickCircleOutlined size="xx-small" variant="success" />
      ) : (
        <DashedCircleOutlined size="xx-small" />
      )}
    </div>
  );
};

TickComponent.propTypes = {
  isCompleted: PropTypes.bool,
};

TickComponent.defaultProps = {
  isCompleted: false,
};

export default TickComponent;
